import { useLocale } from 'next-intl';

import { normalizeLocale } from './utils';
import { SupportedLocale } from './types';

export function useSupportedLocale(): SupportedLocale {
  const locale = useLocale();
  return normalizeLocale(locale);
}
